import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    elections20221Mixin
} from './vue/mixins/elections.2022.1'

initMain([elections20221Mixin], {}, []);
header();